// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".expired-item[data-v-97163c26]{opacity:.6;background-color:rgba(244,67,54,.05)}.expired-item[data-v-97163c26]:hover{background-color:rgba(244,67,54,.1)}.v-list-item--disabled[data-v-97163c26]{pointer-events:auto!important}.dwidth[data-v-97163c26]{width:95%;margin-left:8px!important;margin-right:8px!important}", ""]);
// Exports
module.exports = exports;
